var i18n = {};
var defaultLocale = 'en-us';

i18n['en-us'] = require('./en-us.js');

i18n['zh-cn'] = require('./zh-cn.js');

i18n['in-id'] = require('./in-id.js');

i18n['th-th'] = require('./th-th.js');

i18n['vi-vn'] = require('./vi-vn.js');


for (var locale in i18n) {
  if(!i18n.hasOwnProperty(locale)){
    continue;
  }
  if(locale == defaultLocale){
    continue;
  }
  for(var key in i18n[defaultLocale]){
    if(!i18n[defaultLocale].hasOwnProperty(key)){
      continue;
    }
    if(!i18n[locale].hasOwnProperty(key)){
      i18n[locale][key] = i18n[defaultLocale][key];
    }
  }
}

//把其它信息也加上去
i18n.appName = 'crossborder-merchant-web';
i18n.groupName = 'front_end';
i18n.defaultLocale = defaultLocale;

module.exports = i18n;




//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alife_mcms_crossborder-merchant-web_front_end@0.0.20@@alife/mcms_crossborder-merchant-web_front_end/index.js
// module id = Ef7u
// module chunks = 16